// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// Lovable does not support VITE_* envs in frontend. Use constants (anon key is public).
const SUPABASE_URL = "https://smtjbmylhvcxhnigwsji.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNtdGpibXlsaHZjeGhuaWd3c2ppIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTQyMDc4OTQsImV4cCI6MjA2OTc4Mzg5NH0.Wu9OWi4lRVjPZSQr-_5DGV6WreOWnWvKqb2IkjoGb20";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});